if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

				const openCartButton = document.querySelector('#cart-icon-bubble[role="button"]');
				const formData = new FormData(this.form);
                
				let cartItems;

				if(formData.get("deposit-variant-amount")) {
					let qtyDepost = formData.get("deposit-variant-amount") * formData.get("quantity") || formData.get("deposit-variant-amount");
					cartItems = {
						items: [
							{
								id: formData.get("deposit-variant-id"),
								quantity: qtyDepost
							},
							{
								id: formData.get("id"),
								quantity: formData.get("quantity"),
								selling_plan: formData.get("selling_plan"),
								properties: {
									_deposit_amount: formData.get("deposit-variant-amount")
								}
							}
						],
					};
				} else {
					cartItems = {
						items: [
							{
								id: formData.get("id"),
								quantity: formData.get("quantity"),
								selling_plan: formData.get("selling_plan")
							}
						],
					};
				}

				fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(cartItems),
				})
					.then((response) => response.json())
					.then((response) => {

						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: formData.get("id"), errors: response.description, message: response.message });
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							this.querySelector(".loading-overlay__spinner").classList.add("hidden");

							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						fetch(window.location.href)
							.then((response) => response.text())
							.then((responseText) => {
								const html = new DOMParser().parseFromString(responseText, "text/html");
								const oldDrawer = document.querySelector("cart-drawer");
								const newDrawer = html.querySelector("cart-drawer");
								const oldIconCart = document.querySelector("#cart-icon-bubble");
								const newIconCart = html.querySelector("#cart-icon-bubble");
		
		
								if(oldIconCart && newIconCart) oldIconCart.innerHTML = newIconCart.innerHTML;
								if(oldDrawer && newDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
								if (response.item_count == 0) {
									document.querySelector("cart-drawer").classList.add("is-empty");
								} else {
									document.querySelector("cart-drawer").classList.remove("is-empty");
								}

								document.dispatchEvent(new CustomEvent("rerenderCart"));
							})
							.catch((e) => {
								console.error(e);
							})
							.finally(() => {
								this.submitButton.classList.remove("loading");
								if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
								if (!this.error) this.submitButton.removeAttribute("aria-disabled");
								this.querySelector(".loading-overlay__spinner").classList.add("hidden");

								setTimeout(() => {
									document.querySelector("#cart-icon-bubble").click();
								}, 200);
							});
					});

				// open cart
				setTimeout(() => {
					openCartButton.click();
				}, 500);
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
